import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { useManualQuoteStore } from '@roc/feature-loans';
import { createTextField } from '@roc/ui';


export const ManualQuoteDeclineDialog = observer(() => {
  const { manualQuoteStore } = useManualQuoteStore();

  useEffect(() => {
    manualQuoteStore.declineQuoteFormStore.reset();
    return () => manualQuoteStore.declineQuoteFormStore.reset();
  }, [manualQuoteStore]);

  return (
    <>
      <Grid item xs={12} style={{ marginBottom: 20 }}>
        {createTextField({
          store: manualQuoteStore.declineQuoteFormStore,
          testId: 'message',
          fieldName: 'message',
          label: 'Please provide any additional details or context here',
          multiline: true,
          minRows: 10,
          disabled: false,
          isRequired: true
        })}
      </Grid>
    </>
  );
});
